module.exports = __webpack_public_path__ + "static/media/Spinner.b1531966.gif";